module.exports = __webpack_public_path__ + "static/media/empty_state_noresults.d0db615c.svg";